export interface RolePermissionState {
    // Core data
    data: any;

    // Loading states
    loading: boolean;
    loadingFromCache: boolean;

    // Error handling
    error: any;

    // Cache management
    lastFetchTimestamp: number | null;
    cacheValidUntil: number | null;
    cachedForUsername: string | null;

    // User tracking
    currentUsername: string | null;

    // Feature flags
    isInitialized: boolean;
    hasCachedData: boolean;
}

export const initialRolePermissionState: RolePermissionState = {
    // Core data
    data: null,

    // Loading states
    loading: false,
    loadingFromCache: false,

    // Error handling
    error: null,

    // Cache management
    lastFetchTimestamp: null,
    cacheValidUntil: null,
    cachedForUsername: null,

    // User tracking
    currentUsername: null,

    // Feature flags
    isInitialized: false,
    hasCachedData: false
};

// Cache configuration constants
export const ROLE_PERMISSION_CACHE_CONFIG = {
    // Cache duration in milliseconds (default: 30 minutes)
    CACHE_DURATION_MS: 30 * 60 * 1000,

    // Local storage key for caching
    CACHE_STORAGE_KEY: 'roleAndPermissionMenu',

    // Maximum retry attempts
    MAX_RETRY_ATTEMPTS: 3,

    // Retry delay in milliseconds
    RETRY_DELAY_MS: 1000
};
